import { useTranslation } from "react-i18next";
import React from "react";
import { useAttendanceData } from "../hooks/useAttendanceData";
import DailySchedule from "../components/DailySchedule";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Common/loader";
import PageHeader from "../../../../components/Common/PageHeader";
import { Alert } from "antd";
import CustomAlert from "components/Common/ui/CustomAlert";

const DailySchedulePage: React.FC = () => {
  const { t } = useTranslation();

  const teacherId = useSelector((state: any) => state.authSlice.user?.roleId);
  const { sessions, loading, refresh } = useAttendanceData(teacherId ?? "");

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader
          title={t("todays_schedule")}
          breadcrumbItems={[
            { label: "dashboard", path: "/dashboard" },
            { label: "todays_schedule", active: true }
          ]}
        />

        {loading && <Loader />}
        {!loading && !sessions.length && (
          <CustomAlert message={t("alert.no_sessions_scheduled_for_today.message")} description={t("alert.no_sessions_scheduled_for_today.description")} type="info" showIcon />
        )}
        {!loading && sessions.length > 0 && (
          <DailySchedule sessions={sessions} refreshSessions={refresh} />
        )}
      </div>
    </div>
  );
};

export default DailySchedulePage;
